import { App as AntdApp } from 'antd';
import { useEffect } from 'react';
import notificationService from './notificationService';

const NotificationBridge = () => {
  const { message, notification } = AntdApp.useApp();

  useEffect(() => {
    notificationService.init(notification, message);
  }, [message, notification]);

  return null;
};

export default NotificationBridge;